import { type EKycVerificationStatus } from '@exam-center/graphql';
import { EllipsisText, Label, type GridColDef } from '@shared/components';

import { EKYC_STATUS_COLOR, EKYC_STATUS_TEXT } from '../../constants';

export interface ProctoringEkycListItem {
  id: string;
  name: string;
  email: string;
  status: EKycVerificationStatus;
}

export const columns: GridColDef<ProctoringEkycListItem>[] = [
  {
    field: 'name',
    headerName: 'ชื่อผู้เข้าสอบ',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => {
      return <EllipsisText variant='body1Semibold'>{row.name}</EllipsisText>;
    },
  },
  {
    field: 'email',
    headerName: 'Email',
    sortable: false,
    width: 240,
    renderCell: ({ row }) => {
      return <EllipsisText variant='body1Semibold'>{row.email}</EllipsisText>;
    },
  },
  {
    field: 'status',
    headerName: 'สถานะ e-KYC',
    sortable: false,
    width: 240,
    renderCell: ({ row }) => {
      const statusKey = row.status as keyof typeof EKYC_STATUS_COLOR;
      const labelColor = EKYC_STATUS_COLOR[statusKey];
      return (
        <Label variant='outlined' color={labelColor} size='large'>
          {EKYC_STATUS_TEXT[row.status]}
        </Label>
      );
    },
  },
];
